<template>
  <Maintenance
    v-if="inMaintenance"
    :date="maintenanceEndDate"
    button-text="Try again"
    @leaveButtonClick="$store.dispatch('maintenance/hide')"
  />
  <div v-else>
    <site-wide-alert v-if="showSiteWideAlert" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Maintenance, SiteWideAlert } from '@microbadevs/library'
// @ is an alias to /src
export default {
  components: {
    Maintenance,
    SiteWideAlert
  },
  data: () => ({
    showSiteWideAlert: false
  }),
  computed: {
    ...mapGetters('maintenance', ['inMaintenance', 'maintenanceEndDate'])
  },
  mounted () {
    localStorage.setItem('report_path', process.env.VUE_APP_REPORT_ROOT)
    localStorage.setItem('api_path', process.env.VUE_APP_API_ROOT)
    localStorage.setItem('storage_api_path', process.env.VUE_APP_STORAGE_API)
    localStorage.setItem('public_storage', process.env.VUE_APP_PUBLIC_URL)
    localStorage.setItem('report_m', process.env.VUE_APP_REPORT_M_URL)
  }
}
</script>

<style lang="scss">
  /* @import '../node_modules/bootstrap/scss/bootstrap.scss'; */
  @import './styles/main';
  @import '~@microbadevs/library/dist/@microbadevs/library.css';

  .tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 0 4px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #f9f9f9;

      .popover-inner {
        background: $color;
        color: black;
        padding: 0;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, 0.1);
      }

      .popover-arrow {
        border-color: $color;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.15s;
    }
  }
</style>
